<script lang="ts" setup>
import MDescriptionList, { MDescriptionListItem } from ".";
</script>

<template>
  <div>
    <m-description-list>
      <m-description-list-item
        horizontal
        label="Preferred pronouns"
        value="None recorded"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item
        horizontal
        label="Official name"
        value="MS Juliet SAXBY"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item
        horizontal
        label="Preferred name"
        value="None recorded"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item horizontal label="NHS number" value="969 314 1709" />
      <m-description-list-item
        horizontal
        label="Date of birth"
        value="25 Mar 2014 (9y 2m)"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item
        horizontal
        label="Gender"
        value="Female"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item
        horizontal
        label="Sex at birth"
        value="Not known"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item
        horizontal
        label="Ethnicity"
        value="Not known"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
    </m-description-list>

    <m-description-list>
      <m-description-list-item
        presentation-style="vertical-line"
        label="Third party healthcare professionals"
        value="No sharing restictions"
        :action="{
          icon: 'fa-solid fa-pencil',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
      <m-description-list-item
        presentation-style="vertical-line"
        label="Patient online access"
        value="No sharing restictions"
        :action="{
          icon: 'fa-solid fa-pencil',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />
    </m-description-list>

    <m-description-list>
      <m-description-list-item
        horizontal
        label="Given name too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long"
        value="David"
      />
      <m-description-list-item
        label="Given name too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long too long"
        value="David"
      />
    </m-description-list>

    <m-description-list>
      <m-description-list-item
        horizontal
        label="Multiple line handling"
        value="This
is
multiple
lines"
      />
    </m-description-list>

    <m-description-list>
      <m-description-list-item label="Empty value" horizontal />
      <m-description-list-item
        label="Custom empty value"
        empty-value-text="Empty value recorded"
        horizontal
      />
    </m-description-list>

    <m-description-list>
      <m-description-list-item
        label="Mobile phone number"
        value="07700 123456"
        horizontal
        badge="Preferred for SMS"
      />

      <m-description-list-item
        label="Mobile phone number"
        value="07700 654321"
        horizontal
        :badge="['Multiple', 'String', 'Badges']"
      />

      <m-description-list-item
        label="Mobile phone number"
        value="07700 987654"
        horizontal
        :badge="{ text: 'Object badge' }"
      />

      <m-description-list-item
        label="Mobile phone number"
        value="07700 456789"
        horizontal
        :badge="[{ text: 'Multiple' }, { text: 'Object' }, { text: 'Badges' }]"
      />

      <m-description-list-item
        label="Mobile phone number"
        value="07700 456789"
        horizontal
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />

      <m-description-list-item
        label="Mobile phone number"
        value="07700 456789"
        horizontal
        :badge="[{ text: 'Multiple' }, { text: 'Object' }, { text: 'Badges' }]"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />

      <m-description-list-item
        label="Vertical + badges"
        value="07700 456789"
        :badge="[{ text: 'Multiple' }, { text: 'Object' }, { text: 'Badges' }]"
        :action="{
          icon: 'fa-light fa-chevron-right',
          srLabel: 'Edit this item',
          toSlideover: '#',
        }"
      />

      <m-description-list-item label="Value not passed + badge" badge="badge" />
      <m-description-list-item label="Empty value + badge" value="" badge="badge" />
    </m-description-list>

    <m-description-list>
      <m-description-list-item
        label="Mobile phone number"
        :value="{
          type: 'badge',
          text: '07700 123456',
          colour: 'amber',
          tooltip: 'primary',
        }"
        horizontal
        badge="Preferred for SMS"
      />
      <m-description-list-item
        label="Website"
        :value="{
          type: 'link',
          text: 'medicus.health',
          target: '_blank',
          href: 'http://www.medicus.health',
          inline: true,
        }"
        horizontal
        badge="Homepage"
      />
      <m-description-list-item
        label="Text object value"
        :value="{
          type: 'text',
          text: 'Exmaple text property',
        }"
        horizontal
      />
    </m-description-list>
  </div>
</template>
